export default "__VITE_ASSET__D5VCb4Vv__"